import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const getBanners = createAsyncThunk(
  "banner/getBanners",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/banners?search=${data.search}&filter=${data.filter}&perPage=${data.perPage}&page=${data.page}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to get banner.");
    }
  }
);

export const addBanner = createAsyncThunk(
  "banner/addBanner",
  async (data, { rejectWithValue }) => {
    try {
      let formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (key === 'image' && !(value instanceof File)) {
          formData.append(key, '');
        } else {
          formData.append(key, value);
        }
      });

      let url = "admin/banners";
      if (data.id) {
        url += `/${data.id}`;
      }
      const response = await api.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to add banner");
    }
  }
);

export const deleteBanner = createAsyncThunk(
  "banner/deleteBanner",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.del(`admin/banners/${id}`);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to delete banner");
    }
  }
);

export const changeBannerStatus = createAsyncThunk(
  "banner/changeBannerStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await api.post(`admin/banners/${id}/status`, { status });
      return response;
    } catch (error) {
      console.error("Change status error:", error);
       return rejectWithValue(err.response?.data || "Failed to change status");
    }
  }
);

const bannerSlice = createSlice({
  name: "banner",
  initialState: {
    list_banner: [],
    selected: null,
    loading: false,
    list_loading: false,
    status: "idle",
  },
  reducers: {
    setSelectedBanner(state, action) {
      state.selected = action.payload;
    },
    unsetSelectedBanner(state) {
      state.selected = null;
    },
    resetStatus(state) {
      state.loading = false,
      state.list_loading = false
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(getBanners.pending, (state) => {
      state.list_loading = true;
    })
    .addCase(getBanners.fulfilled, (state, action) => {
      state.list_loading = false;
      state.list_banner = action.payload;
    })
    .addCase(getBanners.rejected, (state) => {
      state.list_loading = false;
    })
    .addCase(addBanner.pending, (state) => {
      state.loading = true;
    })
    .addCase(addBanner.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(addBanner.rejected, (state) => {
      state.loading = false;
    })
    .addCase(deleteBanner.pending, (state) => {
      state.loading = true;
    })
    .addCase(deleteBanner.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(deleteBanner.rejected, (state) => {
      state.loading = false;
    })
    .addCase(changeBannerStatus.pending, (state) => {
      state.loading = true;
    })
    .addCase(changeBannerStatus.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(changeBannerStatus.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { setSelectedBanner, unsetSelectedBanner, resetStatus } = bannerSlice.actions;
export default bannerSlice.reducer;
